<form [formGroup]="formGroup">
    <nuc-form-field label="Variant name">
        <nuc-input formControlName="name" placeholder="Provide a name for the variant"></nuc-input>
    </nuc-form-field>
</form>
